import React from 'react';
import {
  Card,
  CardContent,
  CardActions,
  Typography,
  Button,
  IconButton,
  Tooltip
} from '@mui/material';
import { Star, StarBorder } from '@mui/icons-material';

/**
 * Card view for a dashboard module
 * Displays module icon, name, description, and optional badge
 */
const DashboardModuleCard = ({
  module,
  onClick,
  isPinned = false,
  onPinToggle,
  badge = null
}) => {
  const Icon = module.icon;

  const handlePinClick = (e) => {
    e.stopPropagation();
    onPinToggle?.();
  };

  return (
    <Card
      sx={{
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        transition: 'transform 0.2s ease, box-shadow 0.2s ease',
        '&:hover': {
          transform: 'translateY(-2px)',
          boxShadow: 4
        },
        position: 'relative',
        cursor: 'pointer'
      }}
      onClick={onClick}
    >
      {/* Pin button */}
      <Tooltip title={isPinned ? 'Remove from favorites' : 'Add to favorites'}>
        <IconButton
          size="small"
          onClick={handlePinClick}
          sx={{
            position: 'absolute',
            top: 8,
            right: 8,
            zIndex: 1,
            bgcolor: 'background.paper',
            '&:hover': {
              bgcolor: 'grey.100'
            }
          }}
        >
          {isPinned ? (
            <Star sx={{ color: 'warning.main' }} fontSize="small" />
          ) : (
            <StarBorder fontSize="small" />
          )}
        </IconButton>
      </Tooltip>

      <CardContent sx={{ textAlign: 'center', pt: 4, pb: 1, flex: 1 }}>
        {Icon && (
          <Icon
            sx={{
              fontSize: 48,
              color: 'primary.main',
              mb: 2
            }}
          />
        )}

        <Typography variant="h6" component="h3" gutterBottom>
          {module.name}
        </Typography>

        <Typography variant="body2" color="text.secondary" sx={{ minHeight: 40 }}>
          {module.description}
        </Typography>

        {/* Badge count display */}
        {badge != null && badge > 0 && (
          <Typography
            variant="h4"
            color="primary.main"
            sx={{ mt: 1, fontWeight: 600 }}
          >
            {badge}
          </Typography>
        )}
      </CardContent>

      <CardActions sx={{ justifyContent: 'center', pb: 2 }}>
        <Button
          variant="contained"
          size="small"
          onClick={(e) => {
            e.stopPropagation();
            onClick();
          }}
        >
          {module.action || module.externalUrl ? 'Open' : 'View'}
        </Button>
      </CardActions>
    </Card>
  );
};

export default DashboardModuleCard;
